import { render, staticRenderFns } from "./MakePoint.vue?vue&type=template&id=67198ce6&"
import script from "./MakePoint.vue?vue&type=script&lang=js&"
export * from "./MakePoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports